import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreService} from "../../../../../services/core/core.service";
import {pairwise, startWith} from "rxjs/operators";

@Component({
    selector: ' app-subcontractor-final-preview',
    templateUrl: './subcontractor-final-preview.component.html',
    styleUrls: ['./subcontractor-final-preview.component.scss'],
    standalone: false
})
export class SubcontractorFinalPreviewComponent implements OnInit {

  @Input() model: any = {};
  @Input() form: any = {};
  @Output() callback = new EventEmitter<any>(true);

  public addSubcontractor: any = {};
  public subcontractorDetail: any = {};
  public subcontractorContact:any = {};
  public subcontractorCertificates:any = {};
  public addCoveredAreas:any = {};


  constructor(
    public coreService: CoreService
  ) {
  }

  ngOnInit(): void {
    console.log('model',this.form.get('step04'));

    this.form.get('step01').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.addSubcontractor = next?.addSubcontractor;
      });

    this.form.get('step02').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.subcontractorDetail = next?.subcontractorDetail;
      });

    this.form.get('step03').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.subcontractorContact = next?.subcontractorContact;
      });

    this.form.get('step04').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.subcontractorCertificates = next?.subcontractorCertificates;
      });

    this.form.get('step05').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.addCoveredAreas = next?.addCoveredAreas;
      });
  }

}
